import api from './api';

/**
 * Check if invitation is valid
 */
export const checkInvitation = async (token) => {
  try {
    const response = await api.get(`/invitations/check/${token}`);
    return response.data.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Accept invitation and create account
 */
export const acceptInvitation = async (token, { firstName, lastName, password }) => {
  try {
    const response = await api.post(`/invitations/accept/${token}`, {
      firstName,
      lastName,
      password
    });
    return response.data.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// ============ ADMIN FUNCTIONS ============

/**
 * Get all invitations (admin only)
 */
export const getAllInvitations = async (params = {}) => {
  try {
    const response = await api.get('/invitations/admin/all', { params });
    return response.data.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Send invitation (admin only)
 */
export const sendInvitation = async (invitationData) => {
  try {
    const response = await api.post('/invitations/admin/send', invitationData);
    return response.data.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Cancel invitation (admin only)
 */
export const cancelInvitation = async (invitationId) => {
  try {
    const response = await api.delete(`/invitations/admin/${invitationId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Get invitation statistics (admin only)
 */
export const getInvitationStats = async () => {
  try {
    const response = await api.get('/invitations/admin/stats');
    return response.data.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

const invitationService = {
  checkInvitation,
  acceptInvitation,
  getAllInvitations,
  sendInvitation,
  cancelInvitation,
  getInvitationStats
};

export default invitationService;
